var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRandom = function SvgRandom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01116 7.00828C3.92561 8.63689 3.40055 10.575 3.51556 12.5288L4.57558 12.4664C4.56663 12.312 4.5621 12.1564 4.5621 11.9997C4.5621 7.61396 8.11748 4.05858 12.5033 4.05858C14.9546 4.05858 17.1465 5.16926 18.6032 6.91481L17.0451 8.44992L21.545 9.08852L20.9642 4.58856L19.3577 6.17142C18.2744 4.89687 16.8533 3.94501 15.2503 3.43055C13.3867 2.83242 11.379 2.85812 9.53126 3.50373C7.68357 4.14934 6.09671 5.37968 5.01116 7.00828ZM19.9323 16.9157C21.0019 15.3213 21.5337 13.4267 21.4499 11.5086L20.3888 11.555L20.3888 11.5552C20.5803 15.9368 17.1835 19.644 12.8019 19.8354C10.2909 19.9452 8.00132 18.8764 6.46806 17.1192L8.03734 15.4318L3.51387 14.9903L4.29049 19.4606L5.74551 17.8961C6.85339 19.1368 8.28719 20.05 9.8906 20.5273C11.7307 21.0751 13.6978 21.0201 15.5045 20.3703C17.3111 19.7206 18.8626 18.5101 19.9323 16.9157Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRandom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/random.90d65e11.svg";
export { ForwardRef as ReactComponent };